"use client";

import EnhancedTestimonials from "~/componentsDS/EnhancedTestimonials";
import Badge from "~/componentsDS/Badge";
import Heading from "~/componentsDS/Typography/Heading";
import Reveal from "~/componentsDS/Reveal";
import { cn } from "~/lib/utils";
import { QuizCTA } from "~/components/features/quiz";
import ElementorContainer from "~/componentsDS/ElementorLoyout/ElementorContainer";
import { TestimonialV3 } from "~/componentsDS/EnhancedTestimonials/data";
import { GTM_EVENT_NAMES } from "~/constants/gtmEvents";
import { QUIZ_ROUTES } from "~/constants/quizRoutes";
import { testimonialsData } from "../data/testimonials-data";
import useLpCtaText from "~/hooks/useLpCtaText";
import ReviewsRating from "~/components/Rating/ReviewsRating";
import TextWithRegisteredMark from "~/componentsDS/TextWithRegisteredMark";

type Props = {
    reviewsData?: TestimonialV3[];
    sectionClassName?: string;
    ctaText?: string
}

const ReviewsTestimonialsSection = ({reviewsData = testimonialsData, sectionClassName, ctaText = "Take the 2-min quiz"}: Props) => {

    const ctaTitle = useLpCtaText(ctaText);

    return (
        <section className={cn("pt-16 md:pt-24 pb-0 lg:pb-24", sectionClassName)}>
            <ElementorContainer innerClassName="flex flex-col">
                <div className="flex flex-col md:flex-row md:justify-between md:items-end">
                    <Reveal>
                        <Badge className="mb-2 md:mb-4 font-medium font-suisseBP py-[5px] px-4">Real people, real testimonials</Badge>
                        <Heading
                            as="h2"
                            size="sm"
                            sizes={{ md: "md" }}
                            className="text-primary500"
                        >
                            Hear from{" "}
                            <Heading
                                as="i"
                                font="featureDisplay"
                                weight="400"
                                className="text-[28px] md:text-[36px]"
                            >
                                5000+{" "}
                            </Heading>
                            women
                        </Heading>
                    </Reveal>
                    <ReviewsRating />
                </div>
            </ElementorContainer>

            <div className="relative mt-8">
                <EnhancedTestimonials testimonials={reviewsData} />
            </div>
            <div className="flex justify-center px-6 mt-4">
                <QuizCTA
                    variant="primary"
                    href={QUIZ_ROUTES.HORMONE_IMBALANCE}
                    eventData={{
                        event_name: GTM_EVENT_NAMES.LP_INTERACTION,
                        widget: "real_testimonials",
                        meta_data: {
                            click_text: ctaText,
                        },
                    }}
                    size="md"
                    className="max-md:w-full min-w-[220px]"
                >
                    <TextWithRegisteredMark text={ctaTitle} />
                </QuizCTA>
            </div>
        </section>
    )
};

export default ReviewsTestimonialsSection;
